import { countriesData } from "./countriesData";

// Helper function to get currency symbol
// For MVP - return only Israeli Shekel
export const getCurrencySymbol = (currencyCode = "ILS") => {
  // if (!currencyCode) return "";

  // const country = countriesData.find(
  //   (c) => c.currency.abbreviation === currencyCode.toUpperCase()
  // );

  // return country ? country.currency.symbol : currencyCode;
  return countriesData.find( (country) => country.name === "Israel").currency.symbol;
};

// Helper function to get unique country calling codes
export const getCountryCallingCodes = () => {
  const codes = countriesData
    .map((country) => country.calling_code)
    .filter(Boolean);

  const uniqueCodes = [...new Set(codes)];

  const codesWithPlus = uniqueCodes.map((code) =>
    code.startsWith("+") ? code : `+${code}`
  );

  return codesWithPlus.sort((a, b) =>
    a.localeCompare(b, undefined, { numeric: true })
  );
};
